
    import '/opt/buildhome/repo/components/x-provider/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["x-provider-demo-use"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/x-provider/index.en-US.md?type=demo')
};